import React from 'react';
import { Helmet } from 'react-helmet';
import '../assets/css/LegalNotice.css';

function LegalNotice() {
    return (
        <>
            <Helmet>
                <title>Secouristes Français Croix Blanche | Mentions légales</title>
                <link rel="canonical" href="https://croixblanche-42.org/mentions-legales" />
            </Helmet>
        <div className="legalnotice-container my-5">
            <h1 className="legalnotice-section-title">Mentions légales</h1>
            
            <h3 className="mt-4">Présentation du site</h3>
            <p>
                Conformément aux dispositions des articles 6-III et 19 de la Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique (L.C.E.N.), nous portons à la connaissance des utilisateurs et visiteurs du site <a href="https://www.croixblanche-42.org">www.croixblanche-42.org</a> les informations suivantes :
            </p>
            <ul>
                <li><strong>Statut du propriétaire :</strong> Association Loi 1901 reconnue d’utilité publique</li>
                <li><strong>Propriétaire :</strong> Fédération des Secouristes Français Croix Blanche de la Loire</li>
                <li><strong>Adresse :</strong> 13 Rue de la Glacière - 42120 Le Coteau</li>
                <li><strong>Téléphone :</strong> +33 6 08 62 40 75</li>
                <li><strong>Email :</strong> <a href="mailto:contact@croixblanche-42.org">contact@croixblanche-42.org</a></li>
                <li><strong>N° SIRET :</strong> 80175904400010</li>
                <li><strong>Responsable de la publication :</strong> Président du comité départemental de la Loire M DRESCHER Tomy</li>
                <li><strong>Webmaster :</strong> <a href="mailto:webmaster@croixblanche-42.org">webmaster@croixblanche-42.org</a></li>
                <li><strong>Conception :</strong> LCO</li>
                <li><strong>Hébergement :</strong> 14 rue des Thermes Romains 42300 Roanne</li>
            </ul>

            <h3 className="mt-4">Conditions générales d’utilisation</h3>
            <p>
                L’utilisation du site <a href="https://www.croixblanche-42.org">www.croixblanche-42.org</a> implique l’acceptation pleine et entière des conditions générales d’utilisation décrites ci-après. Ces conditions peuvent être modifiées à tout moment, sans préavis.
            </p>
            <p>
                Le site est accessible 24h/24 et 7j/7 sauf interruption pour maintenance. En cas d’interruption, le site s’efforcera de communiquer préalablement les dates et heures de l’intervention.
            </p>

            <h3 className="mt-4">Description des services fournis</h3>
            <p>
                Le site a pour objet de fournir des informations sur l’ensemble des activités de l’association. Le propriétaire s’efforce de fournir des informations précises et à jour mais ne peut être tenu responsable des inexactitudes ou des omissions.
            </p>

            <h3 className="mt-4">Limites de responsabilité</h3>
            <p>
                Le site utilise la technologie JavaScript. Le propriétaire ne peut être tenu responsable des erreurs ou dommages résultant de l’utilisation du service. L’utilisateur est responsable de son équipement et doit disposer d’un matériel récent, exempt de virus.
            </p>
            <p>
                En cas de message diffamatoire, raciste ou injurieux, le propriétaire se réserve le droit de poursuivre l’utilisateur. Les informations techniques telles que l’adresse IP peuvent être utilisées pour identifier l’auteur.
            </p>

            <h3 className="mt-4">Propriété intellectuelle</h3>
            <p>
                Tous les éléments du site sont protégés par le droit d’auteur. Toute reproduction ou exploitation non autorisée est interdite. Pour toute demande d’autorisation, contactez <a href="mailto:contact@croixblanche-42.org">contact@croixblanche-42.org</a>.
            </p>

            <h3 className="mt-4">Liens hypertextes et cookies</h3>
            <p>
                Le site peut contenir des liens vers d’autres sites. Le propriétaire décline toute responsabilité quant au contenu de ces sites tiers.
            </p>
            <p>
                Lors de la navigation, des cookies peuvent être installés pour améliorer l’expérience utilisateur. Vous pouvez configurer votre navigateur pour refuser les cookies :
            </p>
            <ul>
                <li><strong>Internet Explorer :</strong> Outils → Options Internet → Confidentialité → Bloquer tous les cookies</li>
                <li><strong>Firefox :</strong> Options → Vie privée → Paramètres personnalisés → Désactiver "Accepter les cookies"</li>
                <li><strong>Chrome :</strong> Paramètres → Paramètres avancés → Paramètres de contenu → Bloquer les cookies tiers</li>
            </ul>

            <h3 className="mt-4">Droit applicable</h3>
            <p>
                Tout litige en relation avec l’utilisation du site est soumis au droit français. Les parties acceptent de se soumettre à la compétence exclusive des tribunaux français.
            </p>

            <h3 className="mt-4">Protection des données personnelles</h3>
            <p>
                Le site ne collecte des informations personnelles que pour le besoin des services proposés. L’utilisateur dispose d’un droit d’accès, de rectification et d’opposition qu’il peut exercer en contactant le propriétaire par email à <a href="mailto:webmaster@croixblanche-42.org">webmaster@croixblanche-42.org</a>.
            </p>
        </div>
        </>
    );
}

export default LegalNotice;
